const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async createSaveCampaign({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/saveCampaign", params);
      return data;
    },
    async queryCampaignList({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/queryList", params);
      return data;
    },
    async createCampaignPush({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/promoteCampaign", params);
      return data;
    },
    async queryCampaignDetail({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/getCampaign", params);
      return data;
    },
    async updateCampaignBeEnd({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/stopCampaign", params);
      return data;
    },
    async queryCampaignJoinList({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/detail/queryList", params);
      return data;
    },
    async queryCampaignStatistic({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/statisticCampaign", params);
      return data;
    },
    async querylotteryList({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/queryList", params);
      return data;
    },
    async createSaveLottery({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/saveCampaign", params);
      return data;
    },
    async updateLotteryBeEnd({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/stopCampaign", params);
      return data;
    },
    async queryLotteryDetail({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/getCampaign", params);
      return data;
    },
    async queryLotteryStatistic({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/statisticCampaign", params);
      return data;
    },
    async queryLotteryJoinList({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/detail/queryList", params);
      return data;
    },
    async updateAwardSendStatus({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/award", params);
      return data;
    },
    async queryCustomerListByCollect({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/store/queryCustomers", params);
      return data;
    },
    async queryCustomerListByLottery({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/store/queryCustomers", params);
      return data;
    },
    async queryCustomerListByFission({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/store/queryCustomers", params);
      return data;
    },
    async createLotteryPush({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/promoteCampaign", params);
      return data;
    },
    async queryFissionH5ShareUrl({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/getFissionOfficialAccountCodeUrl", params);
      return data;
    },
    // 查询op积客活动
    async queryOpCollectCustomerList({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/solicit/queryOpOngoingActivity", params);
      return data;
    },
    // 查询op裂变活动
    async queryOpFissionList({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/fission/queryOpOngoingActivity", params);
      return data;
    },
    // 查询op抽奖活动
    async queryOplotteryList({ rootState }, params = {}) {
      const data = await rootState.http("/campaign/game/queryOpOngoingActivity", params);
      return data;
    }
  }
};

export default store;
